import { useMutation, useQuery, UseQueryResult } from '@tanstack/react-query';
import { queryKeysClient } from 'common/clients/query-key.client';
import { EQueryKeys } from 'common/enums/query-kyes.enum';
import { createEmployeeService, updateEmployeeService } from '../services/employees.service';
import {
  TCounterpartyBranchesReqParams,
  TEmployeesListResData,
  TCounterpartyBranchEmployeesResData,
  TUpdateEmployeesReqData, TCreateEmployeesReqData,
} from '../types/employees.types';

export const useGetEmployeesQuery_MultiRole = (
  counterpartyGUID: string,
  branchGUID: string,
  params: TCounterpartyBranchesReqParams,
  hasAccessForAllBranches?: boolean,
  options?: any,
): UseQueryResult<TEmployeesListResData | TCounterpartyBranchEmployeesResData> =>
  useQuery({
    ...queryKeysClient[EQueryKeys.EmployeesQueryKeys]
      .getEmployees_MultiRole(params, counterpartyGUID, branchGUID, hasAccessForAllBranches),
    ...options,
  });

export const useCreateEmployeeMutation = (): any =>
  useMutation({
    mutationFn: (data: { counterpartyGUID: string; requestData: TCreateEmployeesReqData }) =>
      createEmployeeService(data.counterpartyGUID, data.requestData),
  });

export const useUpdateEmployeeMutation = (): any =>
  useMutation({
    mutationFn: (data: { counterpartyGUID: string; employeeGUID: string; requestData: TUpdateEmployeesReqData }) =>
      updateEmployeeService(data.counterpartyGUID, data.employeeGUID, data.requestData),
  });
